import type { RouteRecordRaw } from 'vue-router'

import type { AccessLevel } from '@/types/auth.types'

/**
 * Pipeline routes (§8 — kanban + calendar). OWNER: fe-model (Phase 2).
 *
 * Registered ONCE in `router/index.ts` by fe-nav. fe-model adds new
 * pipeline-area routes here — never in index.ts or pms.routes.ts.
 * Catch-all stays library-owned in index.ts; never declare one here.
 */
const STAFF: AccessLevel[] = ['access_level.admin', 'access_level.manager']

export const pipelineRoutes: RouteRecordRaw[] = [
  {
    path: '/pms/pipeline',
    name: 'pms-pipeline',
    component: () => import('@/views/pms/pipeline/PipelineView.vue'),
    meta: { access_levels: STAFF },
  },
]
